import React from 'react';
import type { ItemType, Role } from '../../types/framework';
import { ITEM_TYPE_LABEL, domainProgress, isStandard, selectedInDomain } from '../../utils/framework';
type QuestionnairePreviewProps = {
  role: Role;
  selected: number[];
};
export function QuestionnairePreview({
  role,
  selected
}: QuestionnairePreviewProps) {
  let counter = 0;
  return <div className="space-y-4" data-id="element-104" data-mp="1ufvdun5e8z7z">
      {role.domains.map((domain, i) => {
      const items = selectedInDomain(domain, selected);
      const progress = domainProgress(domain, selected);
      return <section key={domain.id} className="border border-slate-200 rounded-lg bg-white overflow-hidden" data-id="element-105" data-mp="1gi6vblysu463" data-mpi={i}>
            <header className="flex items-center justify-between px-4 py-2.5 bg-slate-50 border-b border-slate-200" data-id="element-106" data-mp="1bk5buzxgo2u3">
              <h4 className="text-sm font-semibold text-slate-900" data-id="element-107" data-mp="3avobgnwvjyr3">
                {i + 1}. {domain.name}
              </h4>
              {!progress.complete && <span className="text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full" data-id="element-108" data-mp="28zy4wi4wsa0n">
                  Incomplete
                </span>}
            </header>
            <div className="divide-y divide-slate-100" data-id="element-109" data-mp="1z3bllxs8dr0q">
              {(['characteristic', 'behaviour'] as ItemType[]).map(type => {
            const typed = items.filter(it => it.type === type);
            return <div key={type} className="px-4 py-3" data-id="element-110" data-mp="2rss8kfx30fpk">
                    <div className="text-xs font-medium uppercase tracking-wider text-slate-400 mb-2" data-id="element-111" data-mp="2woqu7vr0zjma">
                      {ITEM_TYPE_LABEL[type]}
                    </div>
                    {typed.length === 0 ? <p className="text-sm text-slate-400" data-id="element-112" data-mp="2myebm92ru0is">
                        No questions selected yet.
                      </p> : <ol className="space-y-1.5" data-id="element-113" data-mp="3fgjlnlqg4wrw">
                        {typed.map(item => {
                  counter += 1;
                  return <li key={item.no} className="flex gap-2 text-sm" data-id="element-114" data-mp="3kdf8skcqeqsz">
                              <span className="text-slate-400 w-6 shrink-0 text-right" data-id="element-115" data-mp="3kbcl46z1x9rf">
                                {counter}.
                              </span>
                              <span className="text-slate-800" data-id="element-116" data-mp="3bbpkvoi269zy">
                                {item.criterion}
                                {!isStandard(domain, item) && <span className="ml-2 text-[11px] font-medium text-indigo-700 bg-indigo-50 border border-indigo-100 px-1.5 py-0.5 rounded whitespace-nowrap" data-id="element-117" data-mp="31lmrvoaxsw1m">
                                    Substituted
                                  </span>}
                              </span>
                            </li>;
                })}
                      </ol>}
                  </div>;
          })}
            </div>
          </section>;
    })}
    </div>;
}